import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToasterService } from 'angular2-toaster';
import { ClickableBoxItem, HeaderInfo } from 'app/components/common/clickableBox/clickableBox.component';
import { AuthService } from 'app/services/auth.service';
import { UserRepository } from 'app/services/database/user.repository';
import { DevicesGroupService } from 'app/services/devicesGroup.service';
import { Logger } from 'app/shared/logger';
import { LoggerFactory } from 'app/shared/loggerFactory';
import { DevicesGroupModel } from 'app/views/devices/models/devicesGroup.model';
import { UserModel } from 'app/views/user/models/user.model';
import * as moment from 'moment';

@Component({
    selector: 'psm-devices-groups-list',
    templateUrl: 'devicesGroupsList.component.html'
})

export class DevicesGroupsListComponent implements OnInit {

    // Prevents flickers
    public isDevicesGroupListEmpty: boolean = false;
    public isDevicesGroupListLoading: boolean = false;

    public devicesGroupModels = [];
    public sortedDevicesGroupBoxes: ClickableBoxItem[] = [];

    private user: UserModel;
    private logger: Logger;

    constructor(
        loggerFactory: LoggerFactory,
        private authService: AuthService,
        private devicesGroupService: DevicesGroupService,
        private userRepository: UserRepository,
        private toasterService: ToasterService,
        private translate: TranslateService
    ) {
        this.logger = loggerFactory.create('DevicesGroupListComponent');
    }

    public async ngOnInit() {
        let user = await this.authService.getCurrentUser();
        let uid = user.uid;

        this.user = await this.userRepository.get(uid);

        if (this.user.devicesGroups !== undefined) {
            this.isDevicesGroupListLoading = true;
            try {
                try {
                    this.devicesGroupModels = await this.devicesGroupService.getUserDevicesGroups(uid);
                } catch (err) {
                    this.toasterService.popAsync('error', '', 'modules.devices.groups.failed-to-retrieve-list');
                    this.logger.error(`An error occured while getting devices for user '${uid}'.`, err);
                }
                for (let deviceModel of this.devicesGroupModels) {
                    this.sortedDevicesGroupBoxes.push(await this.createClickableItem(deviceModel));
                }
            } catch (e) {
                this.toasterService.popAsync('error', '', 'modules.devices.groups.failed-to-display-list');
                this.logger.error(`An error occured while displaying devices for user '${uid}'.`, e);
                this.isDevicesGroupListEmpty = true;
            }
        } else {
            this.isDevicesGroupListEmpty = true;
        }
        this.isDevicesGroupListLoading = false;
    }

    private async createClickableItem(group: DevicesGroupModel): Promise<ClickableBoxItem> {
        let link = `/devices/groups/edit/${group.id}`;
        let item = new ClickableBoxItem(group.name, link);
        item.image = '../../../assets/images/group.png';

        let label = await this.translate.get('time.last-modified').toPromise();
        let date = moment(group.modificationDate);
        item.headerInfo.push(new HeaderInfo(label, date.format('LLL'), 'fa fa-pencil-square-o'));

        return item;
    }
}



// WEBPACK FOOTER //
// ./src/app/views/devices/groups/devicesGroupsList.component.ts